<template>
    <div class="d-flex flex-column overflow-auto h-100">
        <div class="p-4 flex-grow-1 overflow-auto">
            <div class="container">
                <div class="row">
                    <div class="col-md-1 pt-5" style="color:red;">
                        {{$t("res_Label_To")}} *
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-3">
                        <StructureUserSelector class="item-min-height"  :showInternalUsers="true" :showExternalUsers="false"
                            :showInternalStructures="true" :showExternalStructures="false"
                            :excludeSelf="false" :isMultiple="false"
                            :selectedStructureUser="transferTo"
                            :hideStructureWithDisableTransfer="!ShowStructuresInTransferForm"
                            @structureUserSelectChanged="transferToBulkSelectedChange"
                            :addressBook_header="$t('res_Label_SelectStructureOrUser')"
                            :ignoreHideInTransfer="false">
                        </StructureUserSelector>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        {{$t("res_Label_Subject")}}
                    </div>
                    <div class="col-md-3" style="color:red;">
                        {{$t("res_Label_Purpose")}} *
                    </div>
                    <div class="col-md-2">
                        {{$t("res_Label_DueDate")}}
                    </div>
                    <div class="col-md-2">
                        {{$t("res_Label_Instruction")}}
                    </div>
                    <div class="col-md-1">
                        
                    </div>
                    <div class="col-md-1">
                        
                    </div>
                </div>
                <div v-for="(item,i) in bulkTransfers" :key="i">
                    <div class="row">
                        <div class="col-md-3">
                            <v-text-field class="text-area item-min-height" v-model="item.subject" solo :disabled="true"></v-text-field>
                        </div>
                        <div class="col-md-3">
                            <multiselect class="light-bg add-arrow item-min-height" v-model="item.purpose"
                                label="name" track-by="id" open-direction="bottom" :options="purpose_items"
                                :searchable="true" :internal-search="false" :clear-on-select="false"
                                :close-on-select="true" :options-limit="300" :max-height="600" :show-no-results="false"
                                :hide-selected="false" :multiple="false" ref="multiselect1" :placeholder="$t('res_Label_SelectOption')">
                            </multiselect>
                        </div>
                        <div class="col-md-2">
                            <v-menu content-class="p-0" v-model="item.transfer_date_menu" :close-on-content-click="false"
                                transition="scale-transition" offset-y left min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field :value="utils.dateFormat(item.dueDate)" :label="$t('res_Label_SelectDate')"
                                        v-bind="attrs" v-on="on" solo append-icon="mdi-calendar" :tabindex="-1">
                                        <template v-slot:append>
                                            <v-icon class="item-min-height" v-bind="attrs" v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker :locale="lang" :min="nowDate" v-model="item.dueDate" @input="item.transfer_date_menu = false"
                                    ></v-date-picker>
                            </v-menu>
                        </div>
                        <div class="col-md-2">
                            <v-text-field class="text-area item-min-height" v-model="item.instruction" solo></v-text-field>
                        </div>
                        <div class="col-md-1">
                            <div class="row">
                                <div class="col-6" v-if="bulkTransfers.length>1">
                                    <v-btn class="dgs-new-button" @click="deleteRow(i)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-1">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-card-actions class="top-shadow gap-3 justify-content-end sticky-actions">
            <v-btn class="light-blue" @click="closeBulkTransferForm()">{{ $t('res_ButtonText_Cancel') }}</v-btn>
            <v-btn @click="bulkTransfer()" class="primary">{{ $t('res_ButtonText_Continue') }}</v-btn>
        </v-card-actions>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import * as utils from '@/assets/js/common.js'
import StructureUserSelector from '@/components/StructureUserSelector.vue'
import Multiselect from 'vue-multiselect'

export default {
    name: 'Bulk-Transfer',
    components: { StructureUserSelector, Multiselect },
    props:
    {
        selectedItems: { type: Array, default: [] },
        purpose_items: { type: Array, default: [] },
    },
    data() {
        return {
            constants: constants,
            utils: utils,
            bulkTransfers: [],
            rowIndex: -1,
            nowDate: new Date().toISOString().slice(0, 10),
            ShowStructuresInTransferForm: window.ShowStructuresInTransferForm,
            lang: sessionStorage.getItem('lang'),
            transferTo: null
        }
    },
    mounted() 
    {
        this.fetchSelectedDocuments();
    },

    methods:
    {
        fetchSelectedDocuments()
        {
            this.bulkTransfers = [];
            this.transferTo = null;

            if( this.selectedItems.length > 0)
            {
                this.selectedItems.forEach(x => {
                    this.bulkTransfers.push({
                            documentId: x.documentId,
                            transferId: x.transferId,
                            subject: x.subject,
                            transferTo: null,
                            purpose: {},
                            dueDate: '',
                            instruction: '',
                            isRowAdded: false,
                            transfer_date_menu: false,
                            isDisabled: true
                        });
                })
            }
        },
        isNullOrUndefined(value)
        {
            return value == null || value == undefined;
        },
        closeBulkTransferForm()
        {
            this.bulkTransfers = [];
            this.$emit('closeBulkTransferForm');
        },
        closeBulkTransferDialog()
        {
            this.bulkTransfers = [];
            this.$emit('closeBulkTransferDialog');
        },
        
        setRowIndex(i){
            this.rowIndex = i;
        },
        transferToBulkSelectedChange(items)
        {
            if(this.bulkTransfers.length > 0 )
            {
                this.bulkTransfers.forEach(x => {
                    x.transferTo = items;
                })
            }
        },
        checkRowValid(item){
            if(JSON.stringify(item.transferTo) === '{}' || item.transferTo === null || item.transferTo.id === 0){
                window.showAlert(this.$t('res_Msgs_StructureOrUserNeeded'), 'warning');
                return false;
            }
            if(JSON.stringify(item.purpose) === '{}' || item.purpose === null){
                window.showAlert(this.$t('res_Msgs_PurposeNeeded'), 'warning');
                return false;
            }
            return true;
        },
        deleteRow(index){
            this.bulkTransfers.splice(index, 1);
        },
        bulkTransfer()
        {
            //this loop is to check validation
            var hasNonCc = false;
            for (var i = 0; i< this.bulkTransfers.length; i++)
            {
                if(i == this.bulkTransfers.length-1 && this.bulkTransfers.length > 1){
                    if((JSON.stringify(this.bulkTransfers[i].transferTo) === '{}' || this.bulkTransfers[i].transferTo === null || this.bulkTransfers[i].transferTo.id === 0) && (JSON.stringify(this.bulkTransfers[i].purpose) === '{}' || this.bulkTransfers[i].purpose === null))
                    {
                        continue;
                    }
                    else if(!this.checkRowValid(this.bulkTransfers[i])){
                        return;
                    }
                }
                else if(!this.checkRowValid(this.bulkTransfers[i])){
                    return;
                }
                if(this.bulkTransfers[i].purpose.id != constants.purposesEnum.CCed){
                    hasNonCc = true;
                }
            }

            if (!hasNonCc)
            {
                window.showAlert(this.$t('res_Msgs_AllCc'), 'warning');
                return
            }
            
            var requestBody = [];
            this.bulkTransfers.forEach(element => {
                var item = {
                    transferId: element.transferId,
                    documentId: element.documentId,
                    forwardTo: [element.transferTo],
                    purpose: element.purpose.id,
                    dueDate: element.dueDate,
                    note: this.escapeHTML(element.instruction)
                }
                requestBody.push(item);
            });

            window.showLoading();
            axios.post(constants.baseApiUrl + 'Transfer/TransferDocumentList', requestBody, { headers: constants.headers })
                .then(res => 
                {
                    if (res.data == true)
                    {
                        this.closeBulkTransferDialog();
                        window.showAlert(this.$t('res_Msgs_DocumentTransferSuccess'), 'success')
                    }
                    else if (res.data == false)
                    {
                        window.showAlert(this.$t('res_Msgs_DocumentTransferFailed'), 'error')
                    }
                    else if (res.data == "Faild")
                    {
                        window.showAlert(this.$t('res_Msgs_DocumentTransferPurposeFailed'), 'warning')
                    }
                    else{ //We got a list of forwatdTo Name and Purpose
                        var notCompleted = '';
                        var retData = res.data;
                        for(var i = 0; i< retData.length; i++){
                            var notCompletedPpurpose = this.purpose_items.find(x=>x.id == retData[i].purpose)
                            notCompleted += `name: ${retData[i].name}, purpose: ${notCompletedPpurpose.name}\n`
                        }
                        window.showAlert(this.$t('res_Msgs_NotCompletedTransfers') + "\n" + notCompleted, 'warning')

                        this.closeBulkTransferForm();
                    }

                })
                .catch(error => console.log(error))
                .finally(() => window.hideLoading());
        },
        escapeHTML(input) 
        {
            const map = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                "'": '&#039;'
            };

            return String(input).replace(/[&<>"']/g, function(match) {
                return map[match];
            });
        }
    },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

    .item-min-height {
        min-height: 45px;
    }

</style> 